const area = [
  {label: 'Abu Dhabi', value: 'A2-AUH'},
  {label: 'Adelaide', value: 'A1-ADL'},
  {label: 'Addis Ababa', value: 'A2-ADD'},
  //  {label: 'Afghanistan', value: 'A2-AF'},
  {label: 'Alaska', value: 'A3-ALA'},
  {label: 'Albania', value: 'A2-AL'},
  {label: 'Algeria', value: 'A2-DZ'},
  {label: 'Almaty', value: 'A2-ALM'},
  {label: 'Amman', value: 'A2-AMM'},
  {label: 'Amritsar', value: 'A1-ASR'},
  {label: 'Amsterdam', value: 'A2-AMS'},
  {label: 'Anchorage', value: 'A3-ANC'},
  {label: 'Andorra', value: 'A2-AD'},
  {label: 'Angola', value: 'A2-AO'},
  {label: 'Antarctica', value: 'A2-AT'},
  {label: 'Antigua and Barbuda', value: 'A2-AG'},
  {label: 'Argentina', value: 'A2-AR'},
  {label: 'Armenia', value: 'A2-AM'},
  {label: 'Aruba', value: 'A2-AW'},
  {label: 'Ashgabat', value: 'A2-ASB'},
  {label: 'Athens', value: 'A2-ATH'},
  {label: 'Atlanta', value: 'A3-ATL'},
  {label: 'Auckland', value: 'A1-AUK'},
  {label: 'Australia', value: 'A1-AU'},
  {label: 'Austria', value: 'A2-AT'},
  {label: 'Azerbaijan', value: 'A2-AZ'},
  {label: 'Baghdad', value: 'A2-BGD'},
  {label: 'Bahrain', value: 'A2-BH'},
  {label: 'Bali', value: 'A1-BLI'},
  {label: 'Bandar Aceh', value: 'A1-BDA'},
  {label: 'Bandung', value: 'A1-BDG'},
  {label: 'Bangalore', value: 'A1-BGR'},
  {label: 'Bangkok', value: 'A1-BKK'},
  {label: 'Bangladesh', value: 'A1-BD'},
  {label: 'Barbados', value: 'A2-BB'},
  {label: 'Barcelona', value: 'A2-BRC'},
  {label: 'Beijing', value: 'A1-BEJ'},
  {label: 'Belgium', value: 'A2-BE'},
  {label: 'Belize', value: 'A2-BZ'},
  {label: 'Bengaluru', value: 'A1-BGL'},
  {label: 'Benin', value: 'A2-BJ'},
  {label: 'Berlin', value: 'A2-BLN'},
  {label: 'Bermuda', value: 'A2-BM'},
  {label: 'Bhubaneswar', value: 'A1-BBS'},
  {label: 'Bhutan', value: 'A2-BT'},
  {label: 'Bolivia', value: 'A2-BO'},
  {label: 'Bordeaux', value: 'A2-BDX'},
  {label: 'Bosnia and Herzegovina', value: 'A2-BA'},
  {label: 'Botswana', value: 'A2-BW'},
  {label: 'Brazil', value: 'A2-BR'},
  {label: 'Brisbane', value: 'A1-BRB'},
  {label: 'Brunei Darussalam', value: 'A1-BN'},
  {label: 'Brussels', value: 'A2-BRU'},
  {label: 'Budapest', value: 'A2-BDP'},
  {label: 'Bulgaria', value: 'A2-BG'},
  {label: 'Burkina Faso', value: 'A2-BF'},
  //					 {label: 'Burundi', value: 'A2-BI'},
  {label: 'Busan', value: 'A1-BSN'},
  {label: 'Cambodia', value: 'A1-KH'},
  {label: 'Cameroon', value: 'A2-CM'},
  {label: 'Can Tho', value: 'A1-CNT'},
  {label: 'Canada', value: 'A3-CA'},
  {label: 'Cayman Islands', value: 'A2-KY'},
  {label: 'Cape Verde', value: 'A2-CV'},
  {label: 'Central African Republic', value: 'A2-CF'},
  {label: 'Chad', value: 'A2-TD'},
  {label: 'Changsa', value: 'A1-CHS'},
  {label: 'Chengdu', value: 'A1-CHD'},
  {label: 'Chennai', value: 'A1-CNI'},
  {label: 'Chiang Mai', value: 'A1-CHM'},
  {label: 'Chiang Rai', value: 'A1-CRI'},
  {label: 'Chicago', value: 'A3-CCG'},
  {label: 'Chile', value: 'A2-CL'},
  {label: 'China', value: 'A1-CN'},
  {label: 'Chongqing', value: 'A1-CHQ'},
  {label: 'Christchurch', value: 'A1-CHR'},
  {label: 'Christmas Island', value: 'A2-CX'},
  {label: 'Cocos (Keeling) Islands', value: 'A2-CC'},
  {label: 'Cologne', value: 'A2-CLG'},
  {label: 'Colombia', value: 'A2-CO'},
  {label: 'Colombo', value: 'A1-CMB'},
  {label: 'Comoros', value: 'A2-KM'},
  {label: 'Cook Islands', value: 'A2-CK'},
  {label: 'Costa Rica', value: 'A2-CR'},
  {label: 'Croatia', value: 'A2-HR'},
  {label: 'Cyprus', value: 'A2-CY'},
  {label: 'Czech Republic', value: 'A2-CZ'},
  {label: 'Da Lat', value: 'A1-DLT'},
  {label: 'Da Nang', value: 'A1-DAG'},
  {label: 'Darwin', value: 'A1-DWN'},
  {label: 'Delhi', value: 'A1-DEL'},
  {label: 'Denmark', value: 'A2-DK'},
  {label: 'Detroit', value: 'A3-DET'},
  {label: 'Dhaka', value: 'A1-DHK'},
  {label: 'Djibouti', value: 'A2-DJ'},
  {label: 'Dominica', value: 'A2-DM'},
  {label: 'Dominican Republic', value: 'A2-DO'},
  {label: 'Dubai', value: 'A2-DBI'},
  {label: 'Ecuador', value: 'A2-EC'},
  {label: 'Egypt', value: 'A2-EG'},
  {label: 'El Salvador', value: 'A2-SV'},
  {label: 'Equatorial Guinea', value: 'A2-GQ'},
  {label: 'Eritrea', value: 'A2-ER'},
  {label: 'Estonia', value: 'A2-EE'},
  {label: 'Ethiopia', value: 'A2-ET'},
  {label: 'Fiji', value: 'A2-FJ'},
  {label: 'Finland', value: 'A2-FI'},
  {label: 'Florence', value: 'A2-FLR'},
  {label: 'France', value: 'A2-FR'},
  {label: 'Frankfurt', value: 'A2-FRF'},
  {label: 'French Polynesia', value: 'A2-PF'},
  {label: 'Fukuoka', value: 'A1-FKK'},
  {label: 'Fuzhou', value: 'A1-FZH'},
  {label: 'Faroe Islands', value: 'A2-FO'},
  {label: 'Gabon', value: 'A2-GA'},
  {label: 'Georgia', value: 'A2-GE'},
  {label: 'Germany', value: 'A2-DE'},
  {label: 'Ghana', value: 'A2-GH'},
  {label: 'Gold Coast', value: 'A1-GCT'},
  {label: 'Greece', value: 'A2-GR'},
  {label: 'Greenland', value: 'A2-GL'},
  {label: 'Grenada', value: 'A2-GD'},
  {label: 'Guam', value: 'A3-GU'},
  {label: 'Guang Zhou', value: 'A1-GZH'},
  {label: 'Guatemala', value: 'A2-GT'},
  {label: 'Guilin', value: 'A1-GLN'},
  {label: 'Guinea', value: 'A2-GN'},
  //                     {label: 'Guinea-Bissau', value: 'A2-GW'},
  {label: 'Guyana', value: 'A2-GY'},
  {label: 'Haikou', value: 'A1-HAI'},
  {label: 'Haiti', value: 'A2-HT'},
  {label: 'Hamburg', value: 'A2-HAM'},
  {label: 'Hanoi', value: 'A1-HNI'},
  {label: 'Hanover', value: 'A2-HOV'},
  {label: 'Hat Yai', value: 'A1-HYI'},
  {label: 'Ho Chi Minh City', value: 'A1-HCM'},
  {label: 'Hokkaido', value: 'A1-HKD'},
  {label: 'Honduras', value: 'A2-HN'},
  {label: 'Hong Kong', value: 'A1-HK'},
  {label: 'Hua Hin', value: 'A1-HHN'},
  {label: 'Hungary', value: 'A2-HU'},
  {label: 'Hyderabad', value: 'A1-HRB'},
  {label: 'Iceland', value: 'A2-IS'},
  {label: 'India', value: 'A1-IN'},
  {label: 'Indonesia', value: 'A1-ID'},
  {label: 'Iraq', value: 'A2-IQ'},
  {label: 'Ireland', value: 'A2-IE'},
  {label: 'Istanbul', value: 'A2-IST'},
  {label: 'Islamabad', value: 'A1-ILM'},
  {label: 'Italy', value: 'A2-IT'},
  //  {label: 'Israel', value: 'A2-IL'},
  {label: 'Jakarta', value: 'A1-JKT'},
  {label: 'Jamaica', value: 'A2-JM'},
  {label: 'Japan', value: 'A1-JP'},
  {label: 'Jeddah', value: 'A2-JED'},
  {label: 'Jeju Island', value: 'A1-JJI'},
  {label: 'Jordan', value: 'A2-JO'},
  {label: 'Kathmandu', value: 'A2-KTM'},
  {label: 'Kazakhstan', value: 'A2-KZ'},
  {label: 'Kenya', value: 'A2-KE'},
  {label: 'Kaohsiung', value: 'A1-KSG'},
  {label: 'Karachi', value: 'A1-KHI'},
  {label: 'Kiribati', value: 'A2-KI'},
  {label: 'Kochi', value: 'A1-KCI'},
  {label: 'Koh Samui', value: 'A1-KSM'},
  {label: 'Kolkata', value: 'A1-KKT'},
  {label: 'Kosovo', value: 'A2-KV'},
  {label: 'Krabi', value: 'A1-KRB'},
  {label: 'Kunming', value: 'A1-KMG'},
  {label: 'Kuwait', value: 'A2-KW'},
  {label: 'Kyrgyzstan', value: 'A2-KG'},
  {label: 'Kyoto', value: 'A1-KYO'},
  {label: 'Lahore', value: 'A1-LHR'},
  {label: 'Las Vegas', value: 'A3-LVG'},
  {label: 'Latvia', value: 'A2-LV'},
  {label: 'Lebanon', value: 'A2-LB'},
  {label: 'Lesotho', value: 'A2-LS'},
  {label: 'Liberia', value: 'A2-LR'},
  {label: 'Libya', value: 'A2-LY'},
  {label: 'Liechtenstein', value: 'A2-LI'},
  {label: 'Lithuania', value: 'A2-LT'},
  {label: 'Laos', value: 'A1-LA'},
  {label: 'Lombok', value: 'A1-LBK'},
  {label: 'London', value: 'A2-LDN'},
  {label: 'Los Angeles', value: 'A3-LAS'},
  {label: 'Luxembourg', value: 'A2-LU'},
  {label: 'Lyon', value: 'A2-LYN'},
  {label: 'Macau', value: 'A1-MO'},
  {label: 'Macedonia', value: 'A2-MK'},
  {label: 'Madagascar', value: 'A2-MG'},
  {label: 'Madrid', value: 'A2-MRD'},
  {label: 'Makassar', value: 'A1-MKS'},
  {label: 'Malawi', value: 'A2-MW'},
  //                     {label: 'Malaysia', value: 'A1-MY'},
  {label: 'Maldives', value: 'A1-MV'},
  {label: 'Mali', value: 'A2-ML'},
  {label: 'Malta', value: 'A2-MT'},
  {label: 'Manila', value: 'A1-MNL'},
  {label: 'Marseille', value: 'A2-MRS'},
  {label: 'Marshall Islands', value: 'A2-MH'},
  {label: 'Mauritania', value: 'A2-MR'},
  {label: 'Mauritius', value: 'A2-MU'},
  {label: 'Medan', value: 'A1-MDA'},
  {label: 'Medina', value: 'A2-MDN'},
  {label: 'Melbourne', value: 'A1-MBN'},
  {label: 'Mexico', value: 'A2-MX'},
  {label: 'Miami', value: 'A3-MIA'},
  {label: 'Micronesia, Federated States of', value: 'A2-FM'},
  {label: 'Milan', value: 'A2-MLN'},
  {label: 'Moldova', value: 'A2-MD'},
  {label: 'Monaco', value: 'A2-MC'},
  {label: 'Mongolia (Outer)', value: 'A2-MN'},
  {label: 'Montenegro', value: 'A2-ME'},
  {label: 'Morocco', value: 'A2-MA'},
  //					 {label: 'Moscow', value: 'A2-MSK'},
  {label: 'Mozambique', value: 'A2-MZ'},
  {label: 'Mumbai', value: 'A1-MBI'},
  {label: 'Munich', value: 'A2-MUC'},
  {label: 'Muscat', value: 'A2-MCT'},
  {label: 'Myanmar', value: 'A1-MM'},
  {label: 'Nagoya', value: 'A1-NGY'},
  {label: 'Nha Trang', value: 'A1-NHA'},
  {label: 'Namibia', value: 'A2-NA'},
  {label: 'Nanjing', value: 'A1-NJG'},
  {label: 'Nanning', value: 'A1-NNG'},
  {label: 'Nauru', value: 'A2-NR'},
  {label: 'Nepal', value: 'A2-NP'},
  {label: 'Netherlands', value: 'A2-NL'},
  {label: 'New Caledonia', value: 'A2-NC'},
  {label: 'New Zealand', value: 'A1-NZ'},
  {label: 'New York', value: 'A3-NYC'},
  {label: 'Nicaragua', value: 'A2-NI'},
  {label: 'Nice', value: 'A2-NCE'},
  {label: 'Niger', value: 'A2-NE'},
  {label: 'Nigeria', value: 'A2-NG'},
  {label: 'Niue', value: 'A2-NU'},
  {label: 'Norfolk Island', value: 'A2-NF'},
  {label: 'North Pole', value: 'A2-NP'},
  {label: 'Northern Mariana Islands', value: 'A2-MP'},
  {label: 'Norway', value: 'A2-NO'},
  {label: 'Okinawa', value: 'A1-OKN'},
  {label: 'Oman', value: 'A2-OM'},
  {label: 'Osaka', value: 'A1-OSK'},
  {label: 'Padang', value: 'A1-PDG'},
  {label: 'Pakistan', value: 'A1-PK'},
  {label: 'Palau', value: 'A2-PW'},
  {label: 'Palembang', value: 'A1-PLB'},
  //  {label: 'Palestine', value: 'A2-PS'},
  {label: 'Panama', value: 'A2-PA'},
  {label: 'Papua New Guinea', value: 'A2-PG'},
  {label: 'Paraguay', value: 'A2-PY'},
  {label: 'Paris', value: 'A2-PRS'},
  {label: 'Pekanbaru', value: 'A1-PKB'},
  {label: 'Peru', value: 'A2-PE'},
  {label: 'Perth', value: 'A1-PEH'},
  {label: 'Philadephia', value: 'A3-PHA'},
  {label: 'Philippines', value: 'A1-PH'},
  {label: 'Phnom Penh', value: 'A1-PNP'},
  {label: 'Phu Quoc', value: 'A1-PQC'},
  {label: 'Phuket', value: 'A1-PKT'},
  //                   {label: 'Pitcairn Islands', value: 'A2-PN'},
  {label: 'Poland', value: 'A2-PL'},
  {label: 'Portugal', value: 'A2-PT'},
  {label: 'Prague', value: 'A2-PRG'},
  {label: 'QuanZhou', value: 'A1-QZH'},
  {label: 'Qatar', value: 'A2-QA'},
  {label: 'Riyadh', value: 'A2-RIY'},
  {label: 'Romania', value: 'A2-RO'},
  {label: 'Rome', value: 'A2-RME'},
  //                   {label: 'Russia', value: 'A2-RU'},
  {label: 'Rwanda', value: 'A2-RW'},
  {label: 'Saint Kitts and Nevis', value: 'A2-KN'},
  {label: 'Saint Lucia', value: 'A2-LC'},
  //				 {label: 'Saint Petersburg', value: 'A2-SPB'},
  {label: 'Saint Vincent and the Grenadines', value: 'A2-VC'},
  {label: 'Samoa', value: 'A2-WS'},
  {label: 'San Francisco', value: 'A3-SFC'},
  {label: 'San Marino', value: 'A2-SM'},
  {label: 'Sapporo', value: 'A1-SPR'},
  {label: 'Saudi Arabia', value: 'A2-SA'},
  {label: 'Seattle', value: 'A3-SEA'},
  {label: 'Senegal', value: 'A2-SN'},
  {label: 'Seoul', value: 'A1-SEO'},
  {label: 'Serbia', value: 'A2-CS'},
  {label: 'Sevilla', value: 'A2-SVL'},
  {label: 'Seychelles', value: 'A2-SC'},
  {label: 'Shanghai', value: 'A1-SHI'},
  {label: 'Sharjah', value: 'A2-SHJ'},
  {label: 'Shenzhen', value: 'A1-SHZ'},
  {label: 'Siem Reap', value: 'A1-SRP'},
  {label: 'Sierra Leone', value: 'A2-SL'},
  {label: 'Sihanoukville', value: 'A1-SHK'},
  {label: 'Singapore', value: 'A1-SG'},
  {label: 'Slovakia', value: 'A2-SK'},
  {label: 'Slovenia', value: 'A2-SI'},
  {label: 'Solomon Islands', value: 'A2-SB'},
  {label: 'South Africa', value: 'A2-ZA'},
  {label: 'South Korea', value: 'A1-KR'},
  {label: 'Spain', value: 'A2-ES'},
  {label: 'Sri Lanka', value: 'A1-LK'},
  //				 {label: 'St Petersburg', value: 'A2-SPB'},
  {label: 'Stuttgart', value: 'A2-STG'},
  {label: 'Surabaya', value: 'A1-SRB'},
  {label: 'Surat Thani', value: 'A1-SRT'},
  {label: 'Swaziland', value: 'A2-SZ'},
  {label: 'Eswatini', value: 'A2-SZ'},
  {label: 'Sweden', value: 'A2-SE'},
  {label: 'Switzerland', value: 'A2-CH'},
  {label: 'Sydney', value: 'A1-SYD'},
  {label: 'Taipei', value: 'A1-TPI'},
  {label: 'Taiwan', value: 'A1-TW'},
  {label: 'Tajikistan', value: 'A2-TJ'},
  {label: 'Tanzania', value: 'A2-TZ'},
  {label: 'Tashkent', value: 'A2-THK'},
  {label: 'Thailand', value: 'A1-TH'},
  {label: 'The Gambia', value: 'A2-GM'},
  {label: 'The Bahamas', value: 'A2-BS'},
  {label: 'Tibet', value: 'A2-TBT'},
  {label: 'Timor-Leste', value: 'A2-TL'},
  {label: 'Tiruchirappalli', value: 'A1-TRC'},
  {label: 'Togo', value: 'A2-TG'},
  //                     {label: 'Tokelau', value: 'A2-TK'},
  {label: 'Tokyo', value: 'A1-TKO'},
  {label: 'Tonga', value: 'A2-TO'},
  {label: 'Trinidad and Tobago', value: 'A2-TT'},
  {label: 'Tunisia', value: 'A2-TN'},
  {label: 'Turkey', value: 'A2-TR'},
  {label: 'Turkmenistan', value: 'A2-TM'},
  {label: 'Tuvalu', value: 'A2-TV'},
  {label: 'Uganda', value: 'A2-UG'},
  //                   {label: 'Ukraine', value: 'A2-UA'},
  {label: 'United Arab Emirates', value: 'A2-AE'},
  {label: 'United Kingdom', value: 'A2-GB'},
  {label: 'United States of America', value: 'A3-US'},
  // {label: 'United States', value: 'A3-US'},
  {label: 'Uruguay', value: 'A2-UY'},
  {label: 'Uzbekistan', value: 'A2-UZ'},
  {label: 'Valencia', value: 'A2-VLC'},
  {label: 'Vanuatu', value: 'A2-VU'},
  {label: 'Vientiane', value: 'A1-VTN'},
  {label: 'Vatican City', value: 'A2-VC'},
  //  {label: 'Venezuela', value: 'A2-VE'},
  {label: 'Venice', value: 'A2-VNC'},
  {label: 'Vietnam', value: 'A1-VN'},
  //                     {label: 'Wallis and Futuna', value: 'A2-WF'},
  {label: 'Washington', value: 'A3-WAS'},
  {label: 'Wuhan', value: 'A1-WHN'},
  {label: 'Xiamen', value: 'A1-XMN'},
  {label: 'Xian', value: 'A1-XAN'},
  {label: 'Xining', value: 'A1-XIN'},
  {label: 'Yangon', value: 'A1-YAN'},
  {label: 'Yemen', value: 'A2-YE'},
  {label: 'Yogyakarta', value: 'A1-YKT'},
  {label: 'Zambia', value: 'A2-ZM'}
]

export default {
  area
}